import { render, staticRenderFns } from "./menu-item.vue?vue&type=template&id=ca56a186&scoped=true&"
import script from "./menu-item.vue?vue&type=script&lang=js&"
export * from "./menu-item.vue?vue&type=script&lang=js&"
import style0 from "./menu-item.vue?vue&type=style&index=0&id=ca56a186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca56a186",
  null
  
)

export default component.exports